module.exports = __webpack_public_path__ + "static/media/SP_S_Timeless_Sforza_LTGrey.cfd6f5d3.png";